<template>
  <div>
    <van-nav-bar
      title="充值"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>
    <van-form @submit="recharge" style="">
      <van-cell title="当前余额">
        <template #default>
          <span>{{ cash }}元</span>
        </template>
      </van-cell>
      <van-field
        v-model="money"
        type="digit"
        name="money"
        label="充值金额"
        placeholder="充值金额必须为大于100元"
        input-align="right"
        autocomplete="off"
        required
      />
      <van-row v-for="(item, index) in auto_fill_amounts" :key="index">
             <van-col span="6" v-for="(item1, index1) in item" :key="index1">
               <van-button round plain hairline native-type="button" type="danger" size="normal" @click="handleAmount(item1)" style="margin-left: 15%; margin-top: 5px;">{{ item1 }}元</van-button>
             </van-col>
           </van-row>
          <div style="margin-left: 16px;padding-right: 12px;" v-html="notice_1_1"></div>
          <!-- <b>充值须知 ：</b><br />
          <van-row>
            <van-col span="1">1、</van-col>
            <van-col span="23">
              请每一次充值必须获取最新帐号，以免充值无效。<br
            /></van-col>
          </van-row>
          <van-row>
            <van-col span="1">2、</van-col>
            <van-col span="23">
              请必须使用本人帐号充值，避免查不到账。<br
            /></van-col>
          </van-row>
          <van-row>
            <van-col span="1">3、</van-col>
            <van-col span="23">
              转账成功后点“我已转账，申请充值”，平台确认后到账。<br
            /></van-col>
          </van-row>
          <van-row>
            <van-col span="1">4、</van-col>
            <van-col span="23">
              单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。<br
            /></van-col>
          </van-row>
          <van-row>
            <van-col span="1">5、</van-col>
            <van-col span="23">
              单笔充值20万以上，请提前一天联系客服申请vip充值帐户。<br
            /></van-col>
          </van-row> -->
      <div v-if="showRechargeMethod" class="filter-section">
        <div class="filter-title">
          <span>充值方式</span>
          <van-button
            round
            size="mini"
            native-type="button"
            class="filter-toggle"
            :class="{ 'is-open': methodPanelOpen }"
            @click="toggleMethodPanel"
            >{{ methodPanelOpen ? "隐藏" : "显示" }}</van-button
          >
        </div>
        <van-row v-show="methodPanelOpen" class="filter-btns">
          <van-col span="6">
            <van-button
              class="autofillbtn filter-btn"
              :class="{ active: selectedMethod === 'all' }"
              round
              plain
              hairline
              native-type="button"
              type="danger"
              size="small"
              @click="selectMethod('all')"
              >全部</van-button
            >
          </van-col>
          <van-col span="6" v-for="item in rechargeMethodOptions" :key="'method-' + item.value">
            <van-button
              class="autofillbtn filter-btn"
              :class="{ active: selectedMethod === item.value }"
              round
              plain
              hairline
              native-type="button"
              type="danger"
              size="small"
              @click="selectMethod(item.value)"
              >{{ item.label }}</van-button
            >
          </van-col>
        </van-row>
      </div>

      <div v-if="showRechargeChannel" class="filter-section">
        <div class="filter-title">
          <span>充值通道</span>
          <van-button
            round
            size="mini"
            native-type="button"
            class="filter-toggle"
            :class="{ 'is-open': channelPanelOpen }"
            @click="toggleChannelPanel"
            >{{ channelPanelOpen ? "隐藏" : "显示" }}</van-button
          >
        </div>
        <van-row v-show="channelPanelOpen" class="filter-btns">
          <van-col span="6">
            <van-button
              class="autofillbtn filter-btn"
              :class="{ active: selectedSource === 'all' }"
              round
              plain
              hairline
              native-type="button"
              type="danger"
              size="small"
              @click="selectSource('all')"
              >全部</van-button
            >
          </van-col>
          <van-col span="6" v-for="item in rechargeSourceOptions" :key="'source-' + item.id">
            <van-button
              class="autofillbtn filter-btn"
              :class="{ active: selectedSource == item.id }"
              round
              plain
              hairline
              native-type="button"
              type="danger"
              size="small"
              @click="selectSource(item.id)"
              >{{ item.name }}</van-button
            >
          </van-col>
        </van-row>
      </div>

      <div style="border-left: 5px solid red; margin-left: 25px">
        <p style="margin-left: 10px">{{ filterMode ? "充值名称" : "请选择充值类型" }}</p>
      </div>
      <p v-if="filterMode && rechargeType.length === 0" class="recharge-empty">请联系客服</p>
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-row
            v-for="(item, index) in rechargeType"
            :key="item.id || index"
            clickable
            @click="changeInstructions(index,item.type)"
            style="margin-left: 16px; font-size: 14px"
          >
            <van-col span="4">
              <p style="text-align: center; margin: 2px">
                <img style="height: 25px" src="../assets/images/recharge.jpg" />
              </p>
            </van-col>
            <van-col span="16">
              <p style="margin: 2px">{{ item.name }}</p>
              <p v-if="item.latest_recharge == 1" class="latest-tag">上次选择</p>
            </van-col>
            <van-col span="4">
              <p style="margin: 2px"><van-radio :name="index" /></p>
            </van-col>
          </van-row>
        </van-cell-group>
      </van-radio-group>
      <van-popup
        v-model="rechargeMaxPopup"
        closeable
        close-icon="close"
        position="bottom"
        :style="{ height: '15%' }"
      >
        <div>
          <p style="text-align: center; margin-top: 15%">{{ Recharge_Max }}</p>
        </div>
      </van-popup>

      <!--<div class="detail" v-if="radio === '3'">
        <p><span>开户名称:</span> {{ companyBank.name }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.name)">复制</van-button></p>
        <p><span>收款卡号:</span> {{ companyBank.card }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.card)">复制</van-button></p>
        <p><span>收款银行:</span> {{ companyBank.bank }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.bank)">复制</van-button></p>
        <p><span>收款地址:</span> {{ companyBank.address }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(companyBank.address)">复制</van-button></p>
        <p class="red">银行卡转账后,请联系客服,进行入款操作</p>
      </div>
      <div class="detail" v-if="radio === '1'">
        <p><span>支付宝账号:</span> {{ ali_account }} <van-button plain hairline native-type="button" type="danger" size="mini" class="right" @click="handleCopy(ali_account)">复制</van-button></p>
        <p><span>支付宝姓名:</span> {{ ali_accountname }} <van-button plain native-type="button" hairline type="danger" size="mini" class="right" @click="handleCopy(ali_accountname)">复制</van-button></p>
        <p class="red">支付宝转账后,请联系客服,进行入款操作</p>
      </div>-->
      <div style="padding-top: 10px">
        <van-button
          block
          type="danger"
          native-type="submit"
          size="small"
          style="height: 50px"
        >
          <span style="font-size: 15px">下一步</span
          ><br />获取实时入款卡，请自行通过手机/电脑/银行转账
        </van-button>
      </div>

      <!-- <div style="padding: 10px 16px">
        <p style="color: red"><b>活动专区</b></p>
        <van-cell-group>
          <van-cell style="padding: 0px" @click="onSelect(cachBackId)" is-link>
            <template #title>
              <p style="margin: 2px 0px">
                {{ cachBack }}
                <span style="color: red"
                  ><b>{{ cachBackAmount }}</b></span
                >
                {{ cachBackCurrency }}
              </p>
            </template>
          </van-cell>
          <van-cell
            style="padding: 0px"
            @click="onSelect(redPacketesId)"
            is-link
          >
            <template #title>
              <p style="margin: 2px 0px">{{ redPacketes }}</p>
            </template>
          </van-cell>
          <van-cell
            style="padding: 0px"
            @click="onSelect(freeVoucherId)"
            is-link
          >
            <template #title>
              <p style="margin: 2px 0px">{{ freeVoucher }}</p>
            </template>
          </van-cell>
        </van-cell-group>
      </div> -->
    </van-form>
    <div style="padding: 10px 16px; font-size: 13px" v-html="data"></div>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <!-- <CommonLoading ref="commonLoader"></CommonLoading> -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { version } from "../../package";
import { Toast } from "vant";
import CommonLoading from "./CommonLoading";
export default {
  name: "Recharge",
  data() {
    return {
      selectedTypeId: "",
      notice_1_1:"",
      notice_2_1:"",
      notice_2_2:"",
      money: "",
      cash: "",
      radio: 6,
      companyBank: {
        name: "",
        card: "",
        bank: "",
        address: "",
      },
      ali_isactive: 0,
      wechat_isactive: 0,
      ali_account: "",
      ali_accountname: "",
      rechargeType: [],
      rechargeMaxPopup: false,
      Recharge_Max: "",
      titles: [],
      data: "",
      cachBack: "",
      redPacketes: "",
      freeVoucher: "",
      cachBackAmount: "",
      cachBackCurrency: "",
      cachBackId: 0,
      redPacketesId: 0,
      freeVoucherId: 0,
      crypto: {
        money: 0,
        USDTAmount: "",
        qrCode: "",
        endTime: 0,
        rechargeId: 0,
      },
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      qserver_url: "",
      auto_fill_amounts: [],
      showRechargeMethod: false,
      showRechargeChannel: false,
      filterMode: false,
      methodPanelOpen: localStorage.getItem("recharge_method_hidden") !== "1",
      channelPanelOpen: localStorage.getItem("recharge_channel_hidden") !== "1",
      rechargeMethodOptions: [],
      rechargeSourceOptions: [],
      selectedMethod: "all",
      selectedSource: "all",
      allRechargeTypes: [],
    };
  },
  watch: {
    money() {
      if (this.filterMode) {
        this.applyRechargeFilter(false);
      }
    },
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url  });
      } else {
        window.open(this.$store.state.chat_server_url );
      }
    },
    handleAmount(amount){
      let that = this;
      that.money = amount;
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    onSelect(type) {
      this.$router.push({
        name: "Activities",
        params: { type: type },
      });
    },
    getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            action: "recharge_activity",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            let config = resData.data.title;
            // let explain = resData.data.explain;
            // that.explain = explain.replace(/['\n]+/g, "<br>");
            for (let i = 0, len = config.length; i < len; i++) {
              that.titles.push(config[i]);
            }
            that.cachBack = that.titles[0][0];
            that.cachBackAmount = that.titles[0][1];
            that.cachBackCurrency = that.titles[0][2];
            that.cachBackId = that.titles[0][3];
            that.redPacketes = that.titles[1][0];
            that.redPacketesId = that.titles[1][3];
            that.freeVoucher = that.titles[2][0];
            that.freeVoucherId = that.titles[2][3];
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
            that.showRechargeMethod = resData.data.is_recharge_method_show == 1;
            that.showRechargeChannel = resData.data.is_recharge_channel_show == 1;
            that.filterMode = that.showRechargeMethod || that.showRechargeChannel;
            if (that.filterMode && that.allRechargeTypes.length) {
              that.applyRechargeFilter(true);
            }
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getCompanyBank() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data.data;
          if (res.data.code == 1) {
            that.companyBank = resData.bank;
            that.ali_isactive = Number(resData.ali_isactive);
            that.ali_account = resData.ali_account;
            that.ali_accountname = resData.ali_accountname;
            /*if (that.ali_isactive === 1){
                  that.ali_account = resData.ali_account;
                }
                that.wechat_isactive = Number(resData.wechat_isactive);
                if (that.wechat_isactive === 1){
                  that.we_chat_pay = resData.we_chat_pay;
                }*/
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },

    getConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code === 1) {
            if (resData.data.real === null) {
              that.$toast({
                type: "fail",
                message: "还未实名,请前去实名后在充值",
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
              return false;
            } else {
              that.recharge();
            }
          } else if (resData.code === 0 || resData.code === -1) {
            that.$toast.fail(resData.msg);
            return false;
          }
        });
    },

    recharge_has(money) {
      let that = this;
      if (money <= 0 || isNaN(money)) {
        that.$toast.fail("请输入正确的充值金额");
        return false;
      } else if (money < 100) {
        that.$toast.fail("充值金额必须为大于100元");
        return false;
      }
      
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "recharge_has",
            token: sessionStorage.getItem("token"),
            number: money,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 0) {
            
            that.topUpTransit(money);
          } else {
            Dialog.confirm({
              title: "",
              message:
                "您已提交一笔同金额的充值正在审核处理中\n若非新充值请勿重复提交?",
              cancelButtonText: "非新充值",
              confirmButtonText: "继续新充值",
            })
              .then(() => {
                that.topUpTransit(money);
              })
              .catch(() => {
                
              });
          }
        })
        .catch(() => {
          
        });
    },

    recharge() {
      let that = this;
      let money = parseInt(that.money);
      if (money <= 0 || isNaN(money)) {
        that.$toast.fail("请输入正确的充值金额");
        return false;
      } else if (money < 100) {
        that.$toast.fail("充值金额必须为大于100元");
        return false;
      }

      if (!that.rechargeType[that.radio]) {
        that.$toast.fail("请选择充值类型");
        return false;
      }

      let radio = that.rechargeType[that.radio].type;//parseInt(that.radio);
      switch (radio) {
        case 3:
        case 4:
          //case 8:
          //case 9:
          if (money > 2000000) {
            that.$toast.fail("人工入款金额最大金额为200万");
            return false;
          } else {
            that.recharge_has(money);
          }
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "recharge_max_amount",
                token: sessionStorage.getItem("token"),
                type: radio,
                recharge_id: that.selectedTypeId
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                
                let maxamountList = res.data.data;
                if (Object.keys(maxamountList).length > 0) {
                  if (money > res.data.data.amount) {
                    (that.rechargeMaxPopup = true),
                      (that.Recharge_Max = res.data.data.message);
                  } else {
                    that.recharge_has(money);
                  }
                } else {
                  that.recharge_has(money);
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              } else {
                that.$toast.fail(res.data.msg);
              }
            });
          // if (money > 50000){
          //   that.$toast.fail('快速入款金额最大金额为5万');
          //   return false;
          // }else{
          //   that.$router.push({path:'/member/recharge/info',query:{type:radio,number:money}})
          // }
          break;
        case 12:
          
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "recharge_max_amount",
                token: sessionStorage.getItem("token"),
                type: radio,
                recharge_id: that.selectedTypeId
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                
                let maxamountList = res.data.data;
                if (Object.keys(maxamountList).length > 0) {
                  if (money > res.data.data.amount) {
                    (that.rechargeMaxPopup = true),
                      (that.Recharge_Max = res.data.data.message);
                  } else {
                    that.recharge_has(money);
                  }
                } else {
                  that.recharge_has(money);
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                
                that.$toast.fail(res.data.msg);
              } else {
                
                that.$toast.fail(res.data.msg);
              }
            });
          break;
      }

      /*that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "offline_recharge",
              token: sessionStorage.getItem("token"),
              number: money,
              type: that.radio,
              recharge_id: that.selectedTypeId
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                  onClose:function () {
                    that.$router.push('/member/members')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });*/
    },
    topUpTransit(number) {
      let that = this;
      let type = that.rechargeType[that.radio].type;//parseInt(that.radio);
      switch (type) {
        case 3:
        case 4:
          that.$router.push({
            path: "/member/recharge/info",
            query: {
              type: type,
              number: number,
              rechargeTypeId: that.selectedTypeId,
            },
          });
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          that.$router.push({
            path: "/member/recharge/info",
            query: {
              type: type,
              number: number,
              rechargeTypeId: that.selectedTypeId,
            },
          });
          break;
        case 13:
        case 14:
        case 16:
        case 11:
        case 17:
        case 18:
        case 19: 
        case 20:
        case 21:
        case 22:
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "offline_recharge",
                token: sessionStorage.getItem("token"),
                number: number,
                type: type,
                recharge_id: that.selectedTypeId
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                // let winRef = window.open("", "_blank");
                let resData = res.data.data;
                if (resData.url) {
                  if (Capacitor.getPlatform() === "android") {
                    //check if android app, if android app use native plugin to open popup
                    Browser.open({ url: resData.url });
                  } else {
                    
                    // winRef.location = resData.url;
                    Dialog.alert({
                      message: '将在浏览器中打开',
                    }).then(() => {
                      window.open(resData.url, "_blank")
                    });
                  }
                } else {
                  that.$toast.fail(res.data.msg);
                }
              } else if (res.data.code == 2) {
                
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                
                that.$toast.fail(res.data.msg);
              }
            });
          break;
        case 12:
          
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "offline_recharge",
                token: sessionStorage.getItem("token"),
                number: number,
                type: type,
                recharge_id: that.selectedTypeId
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                
                let resData = res.data.data;

                that.topUpStatus = true;
                that.disabled4 = false;
                that.crypto.money = resData.orderAmount;
                that.crypto.USDTAmount = resData.orderUSDTAmount;
                that.crypto.qrCode = resData.qrCodeGenerator;
                that.crypto.rechargeId = resData.recharge_id;
                //that.qrcode(that.crypto.qrCode);
                //that.CountDown();

                that.$router.push({
                  path: "/member/recharge/info",
                  query: {
                    type: type,
                    number: that.crypto.money,
                    USDTAmount: that.crypto.USDTAmount,
                    qrCode: that.crypto.qrCode,
                    rechargeId: that.crypto.rechargeId,
                    rechargeTypeId: that.selectedTypeId,
                  },
                });
              } else if (res.data.code == 2) {
                
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                
                that.$toast.fail(res.data.msg);
              }
            });
          break;
      }
    },
    handleCopy(value) {
      let copy = value;
      let oInput = document.createElement("input");
      oInput.value = copy;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
    getRechargetype() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "account",
            token: sessionStorage.getItem("token"),
            action: "rechargetype",
            app_version: version,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let rechargeType = resData.data.rechargeType || [];
            that.allRechargeTypes = rechargeType;
            that.rechargeMethodOptions = that.normalizeRechargeMethods(
              resData.data.recharge_method
            );
            that.rechargeSourceOptions = Array.isArray(resData.data.recharge_source)
              ? resData.data.recharge_source
              : [];

            if (that.filterMode) {
              that.applyRechargeFilter(true);
            } else {
              that.placeLatestAndSelect(rechargeType.slice(), true);
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    closeRechargeMaxPopup() {
      this.rechargeMaxPopup = false;
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            // that.$toast.fail(res.data.msg);
            
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    normalizeRechargeMethods(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map(function (item) {
        if (item && typeof item === "object") {
          let value = item.value || item.code || item.key || item.id || item.name;
          let label = item.name || item.label || value;
          return { value: value, label: label };
        }
        return { value: item, label: item };
      });
    },
    toggleMethodPanel() {
      this.methodPanelOpen = !this.methodPanelOpen;
      localStorage.setItem("recharge_method_hidden", this.methodPanelOpen ? "0" : "1");
    },
    toggleChannelPanel() {
      this.channelPanelOpen = !this.channelPanelOpen;
      localStorage.setItem("recharge_channel_hidden", this.channelPanelOpen ? "0" : "1");
    },
    selectMethod(value) {
      this.selectedMethod = value;
      this.applyRechargeFilter(false);
    },
    selectSource(value) {
      this.selectedSource = value;
      this.applyRechargeFilter(false);
    },
    applySelectedType(item) {
      if (!item) {
        this.notice_1_1 = "";
        this.notice_2_1 = "";
        this.notice_2_2 = "";
        this.auto_fill_amounts = [];
        this.selectedTypeId = "";
        return;
      }
      this.selectedTypeId = item.id;
      this.notice_1_1 = item.notice_1_1;
      this.notice_2_1 = item.notice_2_1;
      this.notice_2_2 = item.notice_2_2;
      this.auto_fill_amounts = item.auto_fill_amounts;
    },
    applyRechargeFilter(resetSelection) {
      let list = this.allRechargeTypes.slice();
      if (this.showRechargeMethod && this.selectedMethod !== "all") {
        list = list.filter(function (item) {
          return (
            Array.isArray(item.recharge_method) &&
            item.recharge_method.indexOf(this.selectedMethod) !== -1
          );
        }, this);
      }
      if (this.showRechargeChannel && this.selectedSource !== "all") {
        list = list.filter(function (item) {
          return item.type == this.selectedSource;
        }, this);
      }
      if (this.money !== "" && this.money != null) {
        const amount = parseFloat(this.money);
        if (!isNaN(amount)) {
          list = list.filter(function (item) {
            const min = parseFloat(item.min_amount);
            const max = parseFloat(item.max_amount);
            const minOk = isNaN(min) || amount >= min;
            const maxOk = isNaN(max) || amount <= max;
            return minOk && maxOk;
          });
        }
      }
      this.placeLatestAndSelect(list, resetSelection);
    },
    placeLatestAndSelect(list, resetSelection) {
      const latestIndex = list.findIndex(function (item) {
        return item.latest_recharge == 1;
      });
      if (latestIndex > 0) {
        const latest = list.splice(latestIndex, 1)[0];
        list.unshift(latest);
      }
      this.rechargeType = list;
      if (resetSelection) {
        let nextIndex = list.findIndex(function (item) {
          return item.latest_recharge == 1;
        });
        if (nextIndex === -1) {
          nextIndex = list.findIndex(function (item) {
            return item.isdefault == 1;
          });
        }
        if (nextIndex >= 0) {
          this.radio = nextIndex;
          this.applySelectedType(list[nextIndex]);
        } else {
          this.radio = "";
          this.applySelectedType(null);
        }
        return;
      }
      const prevId = this.selectedTypeId;
      if (prevId !== "" && prevId != null) {
        const nextIndex = list.findIndex(function (item) {
          return item.id == prevId;
        });
        if (nextIndex >= 0) {
          this.radio = nextIndex;
          this.applySelectedType(list[nextIndex]);
          return;
        }
      }
      this.radio = "";
    },
    changeInstructions(index,type){
      let that = this;
      that.radio = index;
      let SelectedType = that.rechargeType[index];//that.rechargeType.find((o) => o.type == type);
      that.notice_1_1 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.auto_fill_amounts = SelectedType.auto_fill_amounts;
      that.selectedTypeId = SelectedType.id;
    },
    getData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "information",
            type: 3,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.data=res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.get_qchat_server_url();
    this.isLogin();
    this.getRechargetype();
    this.getUser();
    this.getSysConfig();
    this.getData();
    // this.getCompanyBank()
  },
};
</script>

<style scoped>
.filter-section {
  margin: 8px 15px 0;
}
.filter-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  color: #222;
  margin: 8px 0;
}
.filter-toggle {
  margin-left: 10px;
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 400;
  color: #666;
  background: #fff;
  border: 1px solid #d9d9d9;
}
.filter-btns {
  margin-top: 4px;
}
.filter-btns .van-col {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.latest-tag {
  margin: 2px 2px 0;
  color: #c23b32;
  font-size: 12px;
  white-space: nowrap;
}
.recharge-empty {
  margin: 10px 25px;
  color: #c23b32;
  font-size: 14px;
}
.filter-btns .van-button.filter-btn {
  width: 78px;
  height: 30px;
  margin: 0;
  padding: 0 4px;
  font-size: 12px;
  font-weight: bold;
  color: #ffffff !important;
  background: linear-gradient(45deg, #ff3b3b, #d02e27) !important;
  border: none !important;
  border-radius: 50px !important;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}
.filter-btns .van-button.filter-btn.active {
  background: linear-gradient(45deg, #c41e1e, #8d100c) !important;
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 3px #d02e27;
}
.filter-title .van-button.filter-toggle {
  width: auto;
  min-width: 64px;
  height: 26px;
  margin-left: 10px;
  padding: 0 10px;
  color: #fff;
  background: #888;
  border: 1px solid #888;
}
.filter-title .van-button.filter-toggle.is-open {
  color: #333;
  background: #fff;
  border-color: #d9d9d9;
}
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.detail {
  width: 90%;
  margin: 10px auto 0;
}
.detail p {
  font-size: 14px;
}
.detail span {
  font-weight: bold;
}
.right {
  float: right;
}
.detail-img {
  width: 50%;
  margin: 0 auto;
}
.detail-img p {
  font-size: 14px;
  text-align: center;
}
.red {
  color: #ee0a24;
}
.chatTextDesign {
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>
<style>
#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Recharge.vue